import * as React from 'react';
import { PropsWithChildren } from "react";
import styled from "styled-components";
import { colors } from './colors/color';

export function ErrorLabel(props:PropsWithChildren):JSX.Element
{
    return (
        <Label errorState={true}>
            {props.children}
        </Label>
    )
}

type LabelProps = {
    errorState?:boolean,
    formIndent?:boolean,
    hide?:boolean,
    color?:string
    style?:React.CSSProperties
}
export function Label(props:PropsWithChildren<LabelProps>):JSX.Element
{
    if(props.hide === true)
        return <></>;

    return (
        <StyledLabel style={props.style} errorState={props.errorState===undefined ? false : props.errorState} formIndent={props.formIndent === true} color={props.color}>
            {props.children}
        </StyledLabel>
    )
}

const StyledLabel = styled.label<{errorState:boolean, formIndent:boolean, color?:string}>`
    /* margin-left:${props => props.formIndent ? '16px' : '0px' }; */
    font-family: 'Noto Sans', sans-serif;
    font-size:11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    line-height: 16px;
    text-transform: uppercase;
    
    color:${props => props.errorState 
        ? colors.text.state.error 
        : props.color 
            ? props.color 
            : colors.text.gray.normal
    };
`;